<template>
  <div class="mid_scroll_content">
    <section class="forecastPortfolio border-0">
      <div class="row mt-md-4">
        <div class="col-12 col-lg-8">
          <div
            class="mainTitle mb-4 d-flex align-items-center justify-content-between"
          >
            <div class="leftContet">
              <h3>Dashboard</h3>
              <p class="f-16">Track, Manage, and Forecast your portfolio</p>
            </div>
            <change-account></change-account>
          </div>
          <div class="d-flex align-items-center holdingValue">
            <div class="card-body">
              <p class="mb-0">Estimated</p>
              <p>Holding Value</p>
              <h3 class="secondarycolor">
                {{ formatPrice(totalBtcValue, true) }}
                <span class="f-14 textcolor">BTC</span>
              </h3>
            </div>
            <div class="card-body mx-4">
              <p class="mb-0">Approximate</p>
              <p>USD Value</p>
              <h3 class="secondarycolor">
                {{ formatPrice(totalUsdValue) }}
                <span class="f-14 textcolor">USD</span>
              </h3>
            </div>
            <div class="card-body">
              <p class="d-flex align-items-center justify-content-between">
                Profit/Loss (P&L) <span>24h</span>
              </p>
              <h3
                :class="
                  todaysPnl > 0 ? 'green' : todaysPnl < 0 ? 'red' : 'secondary'
                "
              >
                {{ formatPrice(todaysPnl) }}
                <span class="f-14 textcolor">USD</span>
              </h3>
              <p
                class="mb-0 f-16 d-flex"
                :class="
                  todaysPnl > 0 ? 'green' : todaysPnl < 0 ? 'red' : 'secondary'
                "
              >
                {{ formatPrice(todaysPnlPercentage) }} %
                <feather
                  v-if="todaysPnl > 0"
                  class="ml-1"
                  type="trending-up"
                ></feather
                ><feather
                  v-if="todaysPnl < 0"
                  class="ml-1"
                  type="trending-down"
                ></feather>
              </p>
            </div>
          </div>
          <div class="dashChart blockSpace">
            <h3 class="semibold mb-3">Portfolio Net Worth</h3>
            <div class="mainChart p-2">
              <wallets-chart />
              <!-- <img
                class="w-100 d-block"
                src="../../../../static/website/images/portfolionet-worth.svg"
                alt="Icon"
              /> -->
            </div>
          </div>
          <div class="recentTransaction blockSpace">
            <div
              class="topFilter-bar whiteBar d-flex align-items-center justify-content-between mb-3"
            >
              <h3 class="semibold mb-0">Recent Transactions</h3>
              <div class="tabscrollable">
                <ul class="nav nav-tabs noBG border-0">
                  <li
                    class="nav-item"
                    :class="type == '2' ? 'active' : 'deposit_bg'"
                    @click.prevent="
                      type = '2';
                      page = '1';
                    "
                  >
                    <a class="nav-link" href="#">Completed</a>
                  </li>
                  <li
                    class="nav-item"
                    :class="type == '1' ? 'active' : 'deposit_bg'"
                    @click.prevent="
                      type = '1';
                      page = '1';
                    "
                  >
                    <a class="nav-link" href="#">Open</a>
                  </li>
                  <li
                    class="nav-item"
                    :class="type == '3' ? 'active' : 'deposit_bg'"
                    @click.prevent="
                      type = '3';
                      page = '1';
                    "
                  >
                    <a class="nav-link" href="#">Rejected </a>
                  </li>
                  <li
                    class="nav-item"
                    :class="[
                      type == '4' ? 'active' : 'deposit_bg',
                      { disabled: pageLoader },
                    ]"
                    @click.prevent="
                      type = '4';
                      page = '1';
                    "
                  >
                    <a class="nav-link" href="#">Deposits</a>
                  </li>
                  <li
                    class="nav-item"
                    :class="[
                      type == '5' ? 'active' : 'deposit_bg',
                      { disabled: pageLoader },
                    ]"
                    @click.prevent="
                      type = '5';
                      page = '1';
                    "
                  >
                    <a class="nav-link" href="#">Withdrawals</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="recentTable">
              <table
                class="table table-striped table-bordered"
                v-show="type == '2'"
              >
                <thead class="thead-white">
                  <tr>
                    <!--  v-if='basicAdv' -->
                    <th>Action</th>
                    <th>Order Type</th>
                    <th align="right">Quantity</th>
                  </tr>
                </thead>
                <tbody v-if="orderData('2').length > 0">
                  <tr v-for="(val, index) in orderData('2')" v-if="index < 4">
                    <td>
                      <div class="d-flex coinName">
                        <span class="flex-shrink-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              val.Symbol.split('-')[0].toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="val.Symbol.split('-')[0]"
                            v-if="
                              isImage(val.Symbol.split('-')[0].toLowerCase())
                            "
                          />
                          <span class="firstName" v-else>{{
                            val.Symbol.split("-")[0].charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-3 line-1">
                          <span class="btc" v-if="val.OrderSide == 0"
                            >Sell
                            {{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}</span
                          >
                          <span class="btc" v-else-if="val.OrderSide == 1">
                            Bought
                            {{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}
                          </span>
                          <span class="status complete">Completed</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="type yellowBG">
                        <!-- Instant  -->{{ exchangeTypeS[val.OrderType] }}
                        {{
                          val.OrderSide == 0
                            ? "Sell"
                            : val.OrderSide == 1
                            ? "Buy"
                            : ""
                        }}
                      </span>
                    </td>
                    <td>
                      <span class="line-1 text-right">
                        <p class="f-16 semibold mb-0 themecolor">
                          {{ formatPrice(val.QuantityFilled, true) }}
                        </p>
                        <p class="f-14 mt-1 mb-0">{{ fromDate(val.Closed) }}</p>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="orderData('2')"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '1'"
              >
                <thead class="thead-white">
                  <tr>
                    <!--  v-if='basicAdv' -->
                    <th>Action</th>
                    <th>Order Type</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody v-if="orderData('1').length > 0">
                  <tr v-for="(val, index) in orderData('1')" v-if="index < 4">
                    <td>
                      <div class="d-flex coinName">
                        <span class="flex-shrink-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              val.Symbol.split('-')[0].toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="val.Symbol.split('-')[0]"
                            v-if="
                              isImage(val.Symbol.split('-')[0].toLowerCase())
                            "
                          />
                          <span class="firstName" v-else>{{
                            val.Symbol.split("-")[0].charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-3 line-1">
                          <span class="btc" v-if="val.OrderSide == 0"
                            >Sell
                            {{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}
                          </span>
                          <span class="btc" v-else-if="val.OrderSide == 1">
                            Bought
                            {{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}
                          </span>
                          <span class="status complete">Open</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="type yellowBG">
                        {{ exchangeTypeS[val.OrderType] }}
                        {{
                          val.OrderSide == 0
                            ? "Sell"
                            : val.OrderSide == 1
                            ? "Buy"
                            : ""
                        }}
                      </span>
                    </td>
                    <td>
                      <span class="line-1 text-right">
                        <p class="f-16 semibold mb-0 themecolor">
                          {{ formatPrice(val.Quantity, true) }}
                        </p>
                        <p class="f-14 mt-1 mb-0">{{ fromDate(val.Opened) }}</p>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="orderData('1')"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '3'"
              >
                <thead class="thead-white">
                  <tr>
                    <!--  v-if='basicAdv' -->
                    <th>Action</th>
                    <th>Order Type</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody v-if="orderData('3').length > 0">
                  <tr v-for="(val, index) in orderData('3')" v-if="index < 4">
                    <td>
                      <div class="d-flex coinName">
                        <span class="flex-shrink-0">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              val.Symbol.split('-')[0].toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="val.Symbol.split('-')[0]"
                            v-if="
                              isImage(val.Symbol.split('-')[0].toLowerCase())
                            "
                          />
                          <span class="firstName" v-else>{{
                            val.Symbol.split("-")[0].charAt(0)
                          }}</span>
                        </span>
                        <div class="flex-grow-1 ml-3 line-1">
                          <span class="btc" v-if="val.OrderSide == 0">
                            Sell
                            {{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}
                          </span>
                          <span class="btc" v-else-if="val.OrderSide == 1"
                            >Bought
                            {{
                              getCurrName(val.Symbol.split("-")[0]) ||
                              val.Symbol.split("-")[0]
                            }}
                          </span>
                          <span class="status reject">Rejected</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span class="type yellowBG"
                        ><!-- Instant  -->{{ exchangeTypeS[val.OrderType] }}
                        {{
                          val.OrderSide == 0
                            ? "Sell"
                            : val.OrderSide == 1
                            ? "Buy"
                            : ""
                        }}
                      </span>
                    </td>
                    <td>
                      <span class="line-1 text-right">
                        <p class="f-16 semibold mb-0 themecolor">
                          {{ formatPrice(val.Quantity, true) }}
                        </p>
                        <p class="f-14 mt-1 mb-0">
                          <!-- 2m ago -->{{ fromDate(val.Opened) }}
                        </p>
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="orderData('3')"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '4'"
              >
                <thead class="thead-white">
                  <tr>
                    <!--  v-if='basicAdv' -->
                    <th>Date</th>
                    <th>Exchange</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    'totalRecords' in depsitList && depsitList.totalRecords > 0
                  "
                >
                  <tr v-for="(val, index) in depsitList.records">
                    <td>{{ val.created | moment("DD-MM-YYYY, h:mm:ss a") }}</td>
                    <td>
                      {{ formatPrice(val.amount, true) }} 
                      <p v-if="$env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</p>
                      <p v-else>{{ val.currency || "-" }}</p> 
                    </td>
                    <td>
                      <span
                        class="alert"
                        :class="
                          val.payment_status
                            ? depositStatus[val.payment_status].class
                            : ''
                        "
                      >
                        {{
                          val.payment_status
                            ? depositStatus[val.payment_status].name
                            : "-"
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="depsitList.records"
                  v-else
                ></table-loader>
              </table>
              <table
                class="table table-striped table-bordered"
                v-show="type == '5'"
              >
                <thead class="thead-white">
                  <tr>
                    <!--  v-if='basicAdv' -->
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody
                  v-if="
                    'totalRecords' in withdrawalList &&
                    withdrawalList.totalRecords > 0
                  "
                >
                  <tr v-for="(val, index) in withdrawalList.records">
                    <td>{{ val.created | moment("DD-MM-YYYY, h:mm:ss a") }}</td>
                    <td>
                      {{ formatPrice(val.amount, true) }} 
                      <p v-if="$env_var.restricted_currencies.hasOwnProperty(val.currency)">{{ $env_var.restricted_currencies[val.currency].currency_name }}</p>
                      <p v-else>{{ val.currency || "-" }}</p> 
                    </td>
                    <td>
                      <span
                        class="alert"
                        :class="
                          val.withdrawal_status
                            ? depositStatus[val.withdrawal_status].class
                            : ''
                        "
                      >
                        {{
                          val.withdrawal_status
                            ? depositStatus[val.withdrawal_status].name
                            : "-"
                        }}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-center">
                      <router-link to="/transaction-history"
                        >See All Transactions >></router-link
                      >
                    </td>
                  </tr>
                </tbody>
                <table-loader
                  :pageloader_value="pageLoader"
                  :type="'table'"
                  :colspan="'3'"
                  :listLength="withdrawalList.records"
                  v-else
                ></table-loader>
              </table>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div
            class="d-flex align-items-center justify-content-center flex-wrap"
          >
            <router-link
              :to="{ path: '/deposit-withdrawal', query: { deposit: 'BTC' } }"
              class="cap_btn mr-sm-2 mr-1"
              >Deposit</router-link
            >
            <router-link
              :to="{ path: '/deposit-withdrawal', query: { withdraw: 'BTC' } }"
              class="cap_btn secondaryBG"
              >Withdraw</router-link
            >
          </div>
          <div class="chartPortfolio mt-4">
            <h3 class="semibold mb-3">My Portfolio</h3>
            <currencyChart :currency_list="curencyUsdValList" />
            <div class="tradeGraph mx-0 mt-1">
              <!--  topspace -->
              <div class="row calResHeight">
                <!--  topspace -->
                <div
                  class="col-12 col-lg-6"
                  v-for="(item, key, index) in margin_list"
                  v-if="index < 4"
                >
                  <div class="card-body">
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <div class="d-flex align-items-center">
                        <span class="flex-shrink-0 l-1">
                          <img
                            :src="
                              '../../../../static/website/images/crypto_logos/' +
                              item.currency.toLowerCase() +
                              '.png'
                            "
                            @error="handleImgErr($event)"
                            :alt="item.currency"
                            v-if="isImage(item.currency.toLowerCase())"
                          />
                          <span class="firstName" v-else>{{
                            item.currency.charAt(0)
                          }}</span>
                        </span> 
                        <div class="flex-grow-1 ml-2 line-1 text-start">
                          <p class="themecolor uppercase mb-1 f-14">
                            {{ getCurrName(item.currency) }}
                          </p>
                        </div>
                      </div>
                      <!-- <p class="trade mb-0 f-10 d-flex align-items-center justify-content-end">4.33% <feather size="14px" class="ml-1" type="trending-up"></feather></p> -->
                    </div>
                    <div
                      class="d-flex align-items-center justify-content-between"
                    >
                      <h6 class="medium mt-2 themecolor mb-0">
                        {{ formatPrice(item.amount, true) || 0 }}
                        <!-- <sup class="f-12">ETH</sup> -->
                      </h6>
                      <!-- <span class="minChart"><img src="../../../../static/website/images/graph1.svg" alt="Icon"></span> -->
                    </div>
                    <p class="mb-0 f-14">
                      USD Value:
                      <span
                        v-if="
                          item.amount &&
                          parseFloat(getConvertedValue(item, 'USD')) > 0
                        "
                      >
                        ${{
                          formatPrice(
                            parseFloat(getConvertedValue(item, "USD")).toFixed(
                              3
                            )
                          )
                        }}
                      </span>
                      <span v-else>N/A</span>
                    </p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right mb-0">
                  <router-link to="/wallets" class="link f-14"
                    >More Details >></router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="chartPortfolio p-0 mt-4">
            <h3 class="semibold p-3 mb-0">My Favourites</h3>
            <div>
              <ul class="favourites" v-if="fev_list.length > 0">
                <li
                  class="d-flex align-items-center justify-content-between"
                  v-for="(item, index) in fev_list"
                  v-if="index < 4"
                >
                  <span class="d-flex align-items-center">
                    <span class="flex-shrink-0 l-1">
                      <img
                        :src="
                          '../../../../static/website/images/crypto_logos/' +
                          item.split('-')[0].toLowerCase() +
                          '.png'
                        "
                        @error="handleImgErr($event)"
                        :alt="item.split('-')[0]"
                        v-if="isImage(item.split('-')[0].toLowerCase())"
                      />
                    </span>
                    <span class="flex-grow-1 ml-2 line-1 text-start">
                      <p class="themecolor uppercase mb-1 f-14">
                        {{ getCurrName(item.split("-")[0]) }}
                      </p>
                      <!-- <p class="f-12 mb-0">Balance: BTC {{margin_list}}</p> -->
                    </span>
                  </span>
                  <span class="value text-right">
                    <p class="themecolor mb-0 medium">
                      {{
                        instruments[item]
                          ? formatPrice(instruments[item].A, true)
                          : "N/A"
                      }}
                    </p>
                    <p
                      class="mb-0 f-10 d-inline-flex align-items-center justify-content-end"
                      :class="[
                        { trade: formatfloat(instruments[item].CB) > 0 },
                        { 'trade down': formatfloat(instruments[item].CB) < 0 },
                      ]"
                      v-if="instruments[item]"
                    >
                      {{ formatPrice(parseFloat(instruments[item].CB)) }}%
                      <feather
                        size="14px"
                        type="trending-up"
                        v-if="parseFloat(instruments[item].CB) > 0"
                      />
                      <feather
                        size="14px"
                        type="trending-down"
                        v-if="parseFloat(instruments[item].CB) < 0"
                      />
                    </p>
                  </span>
                </li>
                <li class="text-center">
                  <router-link
                    :to="{
                      path: 'markets',
                      query: { filterType: 'Favorites' },
                    }"
                    class="link f-14"
                    >See All Favourites >></router-link
                  >
                </li>
              </ul>
              <no-data v-else />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import tradingMixins from "@/plugins/trading";
import depositWithdrawalMixins from "@/plugins/depositWithdrawal";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import math from "../../../../static/website/js/math.js";
import currencyChart from "../shared/chart/currencyChart";
import walletsChart from "../shared/chart/walletsChart";
import moment from "moment";
export default {
  name: "index",
  mixins: [tradingMixins, depositWithdrawalMixins],
  data() {
    return {
      pageLoader: false,
      notification_msg: "",
      notification_type: "",
      exchangeTypeS: {
        M: "Market",
        S: "Stop",
        L: "Limit",
        SL: "Stop Limit",
      },
      type: "2",
      currency: "",
      freeMargin: 0,
      free_Margin: 0,
      tab: "deposit",
      searchcrypto: "",
      errImage: [],
      fev_list: [],
      margin_list: {}, // currency with ammount available in account
      curencyUsdValList: [],
      currencies: false,
    };
  },
  watch: {
    tradingAccount(value) {
      if (!parseInt(this.accountSelected)) {
        this.getCurrency(value, 1);
        this.allListing(value);
      }
    },
    socialAccount(value) {
      if (parseInt(this.accountSelected) == 1) {
        this.getCurrency(value, 1);
        this.allListing(value);
      }
    },
  },
  components: {
    currencyChart,
    walletsChart,
  },
  computed: {
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return [];
      }
    },
    totalUsdValue() {
      try {
        let amount = 0;
        for (const item in this.margin_list) {
          amount += parseFloat(
            this.getConvertedValue(this.margin_list[item], "USD")
          );
        }
        return amount.toFixed(3);
      } catch (e) {
        return "N/A";
      }
    },
    totalBtcValue() {
      try {
        let amount = 0;
        for (const item in this.margin_list) {
          amount += parseFloat(
            this.getConvertedValue(this.margin_list[item], "BTC")
          );
        }
        return this.formatfloat(amount.toFixed(8));
      } catch (e) {
        return "N/A";
      }
    },
    todaysPnl() {
      if (
        this.totalUsdValue > 0 &&
        this.portfolioReport.length &&
        this.curencyUsdValList.length
      ) {
        let pnl = 0;
        let finalData = {};
        for (let item of this.portfolioReport) {
          let value = parseInt(item.BalanceUSD);
          // let date = moment(item.Date).format("x");
          let date = new Date(item.Date).getTime();
          // console.log(date, new Date(item.Date).getTime());
          if (finalData[item.Currency]) {
            finalData[item.Currency].push({
              value,
              date,
            });
          } else {
            finalData[item.Currency] = [
              {
                value,
                date,
              },
            ];
          }
        }
        for (let key in this.margin_list) {
          if (finalData[this.margin_list[key].currency]) {
            finalData[this.margin_list[key].currency].sort((a, b) => {
              return b.date - a.date;
            });
            pnl +=
              parseFloat(this.getConvertedValue(this.margin_list[key], "USD")) -
              parseFloat(finalData[this.margin_list[key].currency][0].value);
          }
        }
        return pnl;
      } else {
        return 0;
      }
    },
    yesterdaysValue() {
      if (this.portfolioReport.length) {
        let finalData = {};
        let pnl = 0;
        for (let item of this.portfolioReport) {
          let value = parseInt(item.BalanceUSD);
          // let date = moment(item.Date).format("x");
          let date = new Date(item.Date).getTime();
          // console.log(date, new Date(item.Date).getTime());
          if (finalData[item.Currency]) {
            finalData[item.Currency].push({
              value,
              date,
            });
          } else {
            finalData[item.Currency] = [
              {
                value,
                date,
              },
            ];
          }
        }
        for (let key in finalData) {
          if (finalData[key]) {
            finalData[key].sort((a, b) => {
              return b.date - a.date;
            });
            pnl += parseFloat(finalData[key][0].value);
          }
        }
        return pnl;
      } else {
        return 0;
      }
    },
    todaysPnlPercentage() {
      // return 1;
      // console.log(this.totalBtcValue / (this.totalBtcValue + this.todaysPnl));
      return (this.todaysPnl / this.yesterdaysValue) * 100;
    },
  },
  methods: {
    changeCurencyUsdValList() {
      this.currencyData();
      setTimeout(() => {
        this.currencyData();
      }, 5000);
    },
    currencyData() {
      try {
        this.curencyUsdValList = [];
        for (const item in this.margin_list) {
          let index = this.curencyUsdValList
            .map((e) => e.currency)
            .indexOf(this.margin_list[item].currency);
          if (parseFloat(this.margin_list[item].amount)) {
            if (index == -1) {
              this.curencyUsdValList.push({
                currency: this.margin_list[item].currency,
                usdValue: this.getConvertedValue(this.margin_list[item], "USD"),
              });
            } else {
              this.curencyUsdValList[index]["usdValue"] =
                this.getConvertedValue(this.margin_list[item], "USD");
            }
          }
        }
        this.curencyUsdValList.sort(function (a, b) {
          return parseFloat(b.usdValue) - parseFloat(a.usdValue);
        });
      } catch (e) {
        setTimeout(() => {
          this.currencyData();
        }, 1000);
      }
    },
    fromDate(val) {
      return moment(val).fromNow();
    },
    getConvertedValue(item, currency) {
      if (item.currency == currency) {
        return item.amount;
      } else {
        let amount = 0;
        if (this.instruments[item.currency + "-" + currency]) {
          amount = this.instruments[item.currency + "-" + currency].A;
        } else if (this.instruments[currency + "-" + item.currency]) {
          amount = 1 / this.instruments[currency + "-" + item.currency].A;
        } else {
          let basePrice = null,
            reversebasePrice = null,
            pairValue = null,
            revpairValue = null;
          if (currency == "USD") {
            basePrice = this.instruments[item.currency + "-BTC"];
            reversebasePrice = this.instruments["BTC-" + item.currency];
            pairValue =
              this.instruments["BTC-USD"] || this.instruments["BTC-USDT"];
          } else {
            basePrice = this.instruments[item.currency + "-USD"];
            reversebasePrice = this.instruments["USD-" + item.currency];
            pairValue =
              this.instruments["USD-" + currency] ||
              this.instruments["USDT-" + currency];
          }
          if (basePrice && pairValue) {
            amount = pairValue.A * basePrice.A;
          } else if (reversebasePrice && pairValue) {
            amount = pairValue.A / reversebasePrice.A;
          } else {
            amount = 0;
          }
        }
        if (currency == "USD") {
          return (amount * item.amount).toFixed(3);
          // return (amount * item.amount).toFixed(3)
        } else {
          return this.formatfloat(amount * item.amount);
        }
      }
    },
    formatfloat(num) {
      if (num) {
        num = parseFloat(num);
        try {
          return math.format(num, { notation: "fixed" }) || "";
        } catch (e) {
          try {
            return num.toFixed(8);
          } catch (e) {
            return "";
          }
        }
      } else {
        return 0;
      }
    },
    redirect() {
      this.$router.replace({
        name: "support",
        params: { tabName: "openRequest", page: "view_dash" },
      });
    },
    parseFloatVal(val) {
      return parseFloat(val).toFixed(8);
    },
    isImage(img) {
      return this.errImage.includes(img) ? false : true;
    },
    handleImgErr(val) {
      var fullSrc = val.target.src.split(".");
      var src = fullSrc[fullSrc.length - 2].split("/");
      var img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    createClass(index) {
      index++;
      return "p" + index + " col" + index;
    },
    subscribe(subscribeArray) {
      try {
        /*let subscribeArray = [ "BTC-USD", "ETH-USD", "LTC-USD", "BCH-USDT", "ADA-USD", "EOS-USD" ];*/
        this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
          "S_PF_PF"
        ].subscribe(subscribeArray);
      } catch (e) {}
    },
    /*currencyListFunc() {
      try {
        if (this.searchcrypto == "") {
          return this.tradingAccount[0].subAccounts;
        } else {
          return this.tradingAccount[0].subAccounts.filter((val) =>
            val.currency.toLowerCase().includes(this.searchcrypto.toLowerCase())
          );
        }
      } catch (e) { return []; }
    },*/
    allListing(value) {
      if (value.length) {
        var depositData = {
          globalParams: {
            filter: {
              "deposit.account_id": `${value[0].account_id}`,
            },
            sort: [],
            search: "",
            page: "1",
            perPage: 4,
          },
          localParams: { parameter: this },
        };
        var withdrawData = {
          globalParams: {
            filter: {
              "withdrawal.account_id": `${value[0].account_id}`,
            },
            sort: [],
            search: "",
            page: "1",
            perPage: 4,
          },
          localParams: { parameter: this },
        };
        this._runGetDepsitList(depositData);
        this._runGetWithdrawalList(withdrawData);
      }
    },
    orderData(type) {
      if (type == "1") {
        return this.orderList.records.filter((val) => val.Status == "CREATED");
      } else if (type == "2") {
        return this.orderList.records.filter((val) => val.Status == "FILLED");
      } else if (type == "3") {
        return this.orderList.records.filter((val) => val.Status == "CANCELED");
      } else {
        return [];
      }
    },
    getCurrency(value, isCalling) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        /*this.currency = value[0].subAccounts[0];
        let btcPair = value[0].subAccounts.map((val) => val.currency + "-BTC");
        let usdPair = value[0].subAccounts.map((val) => val.currency + "-USD");
        this.subscribPairs(btcPair.concat(usdPair));*/
        this._runGetMarginInfo({
          globalParams: { account_id: value[0].account_id },
          localParams: { parameter: this, page: "home" },
        });
        if (
          value.length > 0 &&
          (this.orderList.records.length == 0 || isCalling)
        ) {
          let jsonData = {
            globalParams: {
              account_id: value[0].account_id,
              demo_live: value[0].demo_live,
            },
            localParams: { parameter: this },
          };
          this._runGetOrderList(jsonData);
        }
      }
    },
    subscribPairs(pairList) {
      /*try {
        if (pairList.length > 0) {
          this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
            "S_PF_PF"
          ].subscribe(pairList);
        }
      } catch (e) {
        setTimeout(() => {
          this.subscribPairs(pairList);
        }, 1000);
      }*/
    },
    /* orderData(){
            return this.orderList.records.filter( val => val.Status == 'FILLED')
        },
		orderlisting(){
			if(this.tradingAccount.length > 0){
				let jsonData = {
					'globalParams' :{
						'account_id' : this.tradingAccount[0].account_id,
						'demo_live' : this.tradingAccount[0].demo_live
					},
					'localParams' :{"parameter" : this, 'page' : 'home'}
				}
				this._runGetOrderList(jsonData)
			}
        }*/
  },
  created() {
    var _that = this;
    this.pageName("Dashboard");
    if (parseInt(this.accountSelected) == 1) {
      this.getCurrency(this.socialAccount, 0);
      if (this.socialAccount.length) {
        this.allListing(this.socialAccount);
      }
    } else {
      this.getCurrency(this.tradingAccount, 0);
      if (this.tradingAccount.length) {
        this.allListing(this.tradingAccount);
      }
    }
    /*setTimeout(function () {
      _that.subscribe([ "BTC-USD", "ETH-USD", "LTC-USD", "BCH-USDT", "ADA-USD", "EOS-USD",]);
    }, 2000);*/
    this._getfavoriteCurrencyList({
      globalParams: { type: "isin" },
      localParams: { parameter: this, page: "home" },
    });
    // this.orderlisting()
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/user/individual_home.vue